export const fallbackRestUrl: string = 'https://api.memvy.com/api';
export const google_client_id: string = '1028556271886-t2cmt38nf056o8skk9qfetj4dqsgo174.apps.googleusercontent.com';
// export const fallbackRestUrl: string = 'http://localhost:3001/api';
export const face_client_id: string = '1446729939533376';
export const base_url: string = 'https://memvy.com';
export const cdn_url: string = 'https://cdn.memvy.com/';
export const base_domain: string = 'memvy.com';
export const stripe_public_key: string = 'pk_live_51QG0MALh0fgkeFSRQj8YPz9LM6kisa3aJ0jbxtXOzaPPjrVd7gi2mjodkpBYmqCv55Hwo5nL6up4SaLEinlV2uH500Cl9eooHU'
